import React, { Component } from 'react';

class Portfolio extends Component {
  render() {

    if (this.props.data) {
      var projects = this.props.data.projects.map(function (projects) {
        var projectImage = 'images/portfolio/' + projects.image;


/*
        var skills = this.props.data.skills.map((skills)=>{
          var className = 'bar-expand '+skills.name.toLowerCase();
          return (
              <li key={skills.name}>
                <span style={{width:skills.level, backgroundColor:this.getRandomColor()}}className={className}></span><em>{skills.name}</em>
              </li>
          )
        })
        */

        return (
          <div key={projects.title} className="columns portfolio-item">
            <div className="item-wrap">
              <a href={projects.url} title={projects.title}>
                <img alt={projects.title} src={projectImage} />
                <div className="overlay">
                  <div className="portfolio-item-meta">
                    <h5>{projects.title}</h5>
                    <p>{projects.category}</p>
                  </div>
                </div>
              </a>
              <div style={{color:'black',paddingLeft:'5px'}}> <i aria-hidden="true" className="fa left-icon fa-trophy" style={{color: '#FFCA22'}}></i> {projects.notes}</div>
            </div>

          </div>
        )
      })
    }

    return (
      <section id="portfolio">

        <div className="row">

          <div className="twelve columns collapsed">

            <h1 style={{marginLeft:'10px'}}>Projects.</h1>

            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
              {projects}
            </div>
          </div>
        </div>

        <div className="row skill" style={{display:'none'}}>

          <div className="three columns header-col" >
            <h1 style={{marginBottom:'20px',marginLeft:'10px'}}><span>Skills</span></h1>
            <div style={{display:'flex',flexWrap: 'nowrap'}}>
              <span style={{backgroundColor:'#e1ffa8',color:'green', margin: '10px', padding: '.2em .6em', textAlign: 'center'}}>Django</span>
              <span style={{backgroundColor:'#e1ffa8',color:'green', margin: '10px', padding: '.2em .6em', textAlign: 'center'}}>Javascript</span>
              <span style={{backgroundColor:'#e1ffa8',color:'green', margin: '10px', padding: '.2em .6em', textAlign: 'center'}}>Payment Gateways</span>
            </div>
            <div>
              <span style={{backgroundColor:'#e1ffa8',color:'green', margin: '10px', padding: '.2em .6em', textAlign: 'center'}}>Firebase</span>
              <span style={{backgroundColor:'#e1ffa8',color:'green', margin: '10px', padding: '.2em .6em', textAlign: 'center'}}>PostgreSQL</span>
              <span style={{backgroundColor:'#e1ffa8',color:'green', margin: '10px', padding: '.2em .6em', textAlign: 'center'}}>Git</span>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

/*      {
        "title": "Register to Vote",
        "category": "Messenger Chatbot to register voters of different state for US National Election by simple Q&A",
        "image": "register_to_vote.png",
        "url": "",
        "notes": "Messenger Chatbot for US Voter Registration",
        "noteLink": "",
        "stack": ["Chatfuel", "Django", "PyPDF2"]
      },

 */

export default Portfolio;



// WEBPACK FOOTER //
// ./src/Components/Portfolio.js